export enum UpmindObjectTypes {
  ACCOUNT = "account",
  ACCOUNT_TYPE = "account_type",
  ACCOUNTS_STATUS = "accounts_status",
  AFFILIATE = "affiliate",
  AFFILIATE_ACCOUNT = "affiliate_account",
  AFFILIATE_ACCOUNT_LINK = "affiliate_account_link",
  AFFILIATE_ACCOUNT_REFERRAL = "affiliate_account_referral",
  AFFILIATE_COOKIE = "affiliate_cookie",
  AFFILIATE_PRODUCT = "affiliate_product",
  AFFILIATE_PRODUCTS_PRICE = "affiliate_products_price",
  AFFILIATE_PROVIDER = "affiliate_provider",
  APPLICATION_LINK = "application_link",
  BILLING_CYCLE = "billing_cycle",
  BRAND = "brand",
  BRAND_HOOK_TEMPLATE = "brand_hook_template",
  BULK_ACTION = "bulk_action",
  BULK_ACTION_OBJECTS = "bulk_action_objects",
  BULK_ACTION_RESULT = "bulk_action_result",
  CARD_TYPES = "card_types",
  CLIENT = "client",
  CLIENT_NOTE = "client_note",
  CLIENTS_ACCOUNT = "clients_account",
  CLIENTS_ADDRESS = "clients_address",
  CLIENTS_COMPANY = "clients_company",
  CLIENTS_EMAIL = "clients_email",
  CLIENTS_IMPORTS = "clients_imports",
  CLIENTS_PAYMENT_DETAIL = "clients_payment_detail",
  CLIENTS_PHONE = "clients_phone",
  CONTRACT = "contract",
  CONTRACT_PRODUCT_DAYS_CORRECTION = "contract_product_days_correction",
  CONTRACT_PRODUCTS_PROMOTION = "contract_products_promotion",
  CONTRACT_PROMOTION = "contract_promotion",
  CONTRACT_PROMOTION_DATA = "contract_promotion_data",
  CONTRACT_REQUEST = "contract_request",
  CONTRACTS_FIELD = "contracts_field",
  CONTRACTS_FIELDS_VALUE = "contracts_fields_value",
  CONTRACTS_PRODUCT = "contracts_product",
  CONTRACTS_SERVICE = "contracts_service",
  CONTRACTS_SUBSCRIPTION = "contracts_subscription",
  COST = "cost",
  COUNTRY = "country",
  CREDIT_DEBIT_TRANSACTION = "credit_debit_transaction",
  CURRENCY = "currency",
  CUSTOM_FIELD = "custom_field",
  CUSTOM_FIELD_VALUE = "custom_field_value",
  DATA_RULE = "data_rule",
  DELEGATED_ACCESS = "delegated_access",
  DEPARTMENT = "department",
  DEPARTMENT_USER = "department_user",
  DOMAINS_PRODUCT = "domains_product",
  DYNAMIC_TRANSLATION = "dynamic_translation",
  EMAIL = "email",
  EMAIL_ATTACHMENT = "email_attachment",
  EMAIL_TICKET_PIPE_LOG = "email_ticket_pipe_log",
  EMAILS_DATA = "emails_data",
  EXCHANGE_RATE = "exchange_rate",
  EXPORTS_SOURCE = "exports_source",
  EXPORTS_SOURCES_ACCOUNT = "exports_sources_account",
  EXTERNAL_EXPORT = "external_export",
  EXTERNAL_IMPORT = "external_import",
  EXTERNAL_IMPORTS_RELATION = "external_imports_relation",
  FILE = "file",
  FILTER = "filter",
  FRAUD_CHECK_SETTING = "fraud_check_setting",
  FRAUD_EVENT = "fraud_event",
  FUNCTIONALITY = "functionality",
  FUNCTIONALITY_CATEGORY = "functionality_category",
  GATEWAY = "gateway",
  GATEWAY_PROVIDER = "gateway_provider",
  GATEWAY_PROVIDER_FIELD = "gateway_provider_field",
  GATEWAYS_BRAND = "gateways_brand",
  GATEWAYS_SETTING = "gateways_setting",
  GRANT_REQUEST = "grant_request",
  GROUP = "group",
  GROUPS_FUNCTIONALITY = "groups_functionality",
  GROUPS_HIDDEN_FIELD = "groups_hidden_field",
  HIDDEN_FIELD = "hidden_field",
  HOOK = "hook",
  HOOK_LOG = "hook_log",
  IMAGE = "image",
  IMAGE_CATEGORY = "image_category",
  IMAGE_CATEGORY_SIZE = "image_category_size",
  IMPORT = "import",
  IMPORT_ID_MAPPING = "import_id_mapping",
  IMPORT_LOG = "import_log",
  IMPORT_SOURCE = "import_source",
  IMPORT_SOURCE_CREDENTIALS = "import_source_credentials",
  IMPORT_SOURCE_DATA = "import_source_data",
  IMPORT_STEP = "import_step",
  INTERACTION = "interaction",
  INTERACTION_CATEGORY = "interaction_category",
  INTERACTION_CHANNEL = "interaction_channel",
  INTERACTION_THREAD = "interaction_thread",
  INVOICE = "invoice",
  INVOICE_DATA = "invoice_data",
  INVOICE_FILE = "invoice_file",
  INVOICE_NUMBER = "invoice_number",
  INVOICE_PAYMENT = "invoice_payment",
  INVOICE_PRODUCT = "invoice_product",
  INVOICE_PRODUCTS_PROMOTION = "invoice_products_promotion",
  INVOICE_PRODUCTS_VOUCHER = "invoice_products_voucher",
  INVOICE_PROMOTION = "invoice_promotion",
  INVOICE_VOUCHER = "invoice_voucher",
  INVOICES_CATEGORY = "invoices_category",
  INVOICES_SUBSCRIPTION = "invoices_subscription",
  LANGUAGE = "language",
  LEAD = "lead",
  LEAD_CLIENT_IMPORT = "lead_client_import",
  LOG_CALLBACK_LOG = "log_callback_log",
  LOG_EVENT = "log_event",
  LOGIN_ATTEMPTS = "login_attempts",
  LOGIN_PROVIDER = "login_provider",
  LOGO = "logo",
  MESSAGE = "message",
  NOTIFICATION_CHANNEL = "notification_channel",
  NOTIFICATION_CHANNEL_RECIPIENT_TYPE = "notification_channel_recipient_type",
  NOTIFICATION_RECIPIENT_TYPE = "notification_recipient_type",
  OAUTH_APPLICATION = "oauth_application",
  OAUTH_APPLICATION_ACCESS_TOKEN = "oauth_application_access_token",
  OAUTH_APPLICATION_AUTHORIZATION = "oauth_application_authorization",
  OAUTH_CLIENT = "oauth_client",
  OAUTH_REFRESH_TOKEN = "oauth_refresh_token",
  OAUTH_SESSION = "oauth_session",
  OBJECT_HOOK_NOTIFICATION_TEMPLATE = "object_hook_notification_template",
  OBJECT_NUMBER = "object_number",
  OBJECT_TAG = "object_tag",
  ORGANISATION = "organisation",
  PAYMENT_RECONCILIATION_LOG = "payment_reconciliation_log",
  PAYMENT_TYPE = "payment_type",
  PAYMENTS_EVENTS_LOG = "payments_events_log",
  PAYMENTS_LOG = "payments_log",
  PENDING_PAYMENT = "pending_payment",
  PREMIUM_DOMAIN = "premium_domain",
  PREMIUM_DOMAINS_CATEGORY = "premium_domains_category",
  PREMIUM_DOMAINS_PRICE = "premium_domains_price",
  PREMIUM_DOMAINS_PRODUCT = "premium_domains_product",
  PRICELIST = "pricelist",
  PRICELISTS_PRODUCT = "pricelists_product",
  PRIORITY = "priority",
  PRODUCT = "product",
  PRODUCT_CATEGORY_MAP = "product_category_map",
  PRODUCT_MIGRATION = "product_migration",
  PRODUCT_RELATED = "product_related",
  PRODUCTS_ATTRIBUTE = "products_attribute",
  PRODUCTS_CATEGORY = "products_category",
  PRODUCTS_GROUP = "products_group",
  PRODUCTS_GROUPS_PRODUCT = "products_groups_product",
  PRODUCTS_OPTION = "products_option",
  PRODUCTS_PROVISION_PROVIDER = "products_provision_provider",
  PRODUCTS_RELATED_PRODUCT = "products_related_product",
  PRODUCTS_SET_PRODUCT = "products_set_product",
  PRODUCTS_SUB_PRODUCT = "products_sub_product",
  PROMOTION = "promotion",
  PROMOTION_BILLING_CYCLES = "promotion_billing_cycles",
  PROMOTION_CURRENCIES = "promotion_currencies",
  PROMOTION_PRICELISTS = "promotion_pricelists",
  PROMOTIONS_CLIENT = "promotions_client",
  PROMOTIONS_MANDATORY_PRODUCT = "promotions_mandatory_product",
  PROMOTIONS_PRODUCT = "promotions_product",
  PROVISION_AFFILIATE_PRODUCTS_FIELDS_VALUE = "provision_affiliate_products_fields_value",
  PROVISION_BLUEPRINT = "provision_blueprint",
  PROVISION_BLUEPRINT_FIELD = "provision_blueprint_field",
  PROVISION_BLUEPRINT_FIELD_VALUE = "provision_blueprint_field_value",
  PROVISION_BLUEPRINT_FUNCTION = "provision_blueprint_function",
  PROVISION_BLUEPRINT_FUNCTION_PARAMETER = "provision_blueprint_function_parameter",
  PROVISION_BLUEPRINT_FUNCTION_TRIGGER = "provision_blueprint_function_trigger",
  PROVISION_BLUEPRINT_RESULT_ACTION = "provision_blueprint_result_action",
  PROVISION_BLUEPRINT_RESULT_ACTION_LOG = "provision_blueprint_result_action_log",
  PROVISION_CALLBACK_LOG = "provision_callback_log",
  PROVISION_CATEGORY = "provision_category",
  PROVISION_CATEGORY_ATTRIBUTE_ID = "provision_category_attribute_id",
  PROVISION_CENTER = "provision_center",
  PROVISION_CONFIGURATION = "provision_configuration",
  PROVISION_CONFIGURATION_ATTRIBUTE = "provision_configuration_attribute",
  PROVISION_CONFIGURATION_ATTRIBUTE_VALUE = "provision_configuration_attribute_value",
  PROVISION_CONFIGURATION_FIELD = "provision_configuration_field",
  PROVISION_DISPATCHER = "provision_dispatcher",
  PROVISION_FIELD = "provision_field",
  PROVISION_FIELDS_VALUE = "provision_fields_value",
  PROVISION_FUNCTION = "provision_function",
  PROVISION_FUNCTION_PARAMETER = "provision_function_parameter",
  PROVISION_FUNCTION_RETURN_DATA = "provision_function_return_data",
  PROVISION_FUNCTIONS_FIELD = "provision_functions_field",
  PROVISION_PRODUCTS_FIELDS_VALUE = "provision_products_fields_value",
  PROVISION_PROVIDER = "provision_provider",
  PROVISION_REQUEST = "provision_request",
  PROVISION_REQUEST_PARAMETER_VALUE = "provision_request_parameter_value",
  PROVISION_RESULT = "provision_result",
  PROVISION_SERVER = "provision_server",
  PROVISION_SERVERS_ORGANISATION = "provision_servers_organisation",
  PROVISION_SERVERS_PROVIDER = "provision_servers_provider",
  QUEUE_MESSAGE = "queue_message",
  RECURRING_INVOICE_LOG = "recurring_invoice_log",
  REGION = "region",
  RELATED_LEAD = "related_lead",
  ROUTE = "route",
  ROUTES_VISIBLE_FIELD = "routes_visible_field",
  SEED_TASK = "seed_task",
  SEGMENT = "segment",
  SETTING_CATEGORY = "setting_category",
  SETTING_FIELD = "setting_field",
  SETTING_GROUP = "setting_group",
  SETTING_VALUE = "setting_value",
  SHARED_RESOURCE_TOKEN = "shared_resource_token",
  SIMILAR_PRODUCT = "similar_product",
  STATUS = "status",
  SUPPORT_EMAIL = "support_email",
  TAG = "tag",
  TAX_BUSINESS_TYPE = "tax_business_type",
  TAX_TAG = "tax_tag",
  TAX_TAG_LOCATION = "tax_tag_location",
  TAX_TEMPLATE = "tax_template",
  TAX_TYPE = "tax_type",
  TEMPLATE = "template",
  TEMPLATES_CATEGORY = "templates_category",
  TEMPLATES_CONTENT = "templates_content",
  TEMPLATES_PARAM = "templates_param",
  TERMS_AND_CONDITIONS = "terms_and_conditions",
  TERMS_AND_CONDITIONS_ACCEPTANCE = "terms_and_conditions_acceptance",
  TERMS_AND_CONDITIONS_DATA = "terms_and_conditions_data",
  TICKET = "ticket",
  TICKET_DEPARTMENT = "ticket_department",
  TICKET_MESSAGE = "ticket_message",
  TICKET_USER = "ticket_user",
  TLD = "tld",
  TRACKED_REFERRAL = "tracked_referral",
  UNIT = "unit",
  UPMIND_PAY_ACCOUNT = "upmind_pay_account",
  UPMIND_PAY_MCC = "upmind_pay_mcc",
  USER = "user",
  USER_BRAND_GROUP = "user_brand_group",
  VALUE_CONFLICT_RESOLUTION_POLICY = "value_conflict_resolution_policy",
  VOUCHER = "voucher",
  VOUCHERS_PRODUCT = "vouchers_product",
  WALLET = "wallet",
  WALLET_REFUND = "wallet_refund",
  WALLET_REFUND_REQUEST = "wallet_refund_request"
}
